//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsPhoenixRestApi,getVendorsApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Selene'

export const getTaskData=(selene:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.SELENE_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,selene)
            dispatch({
                type: actionTypes.SELENE_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.SELENE_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.SELENE_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,seleneResultset:any,selene:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (seleneResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorId=seleneResultset.vendorId;
        payload.vendorName=seleneResultset.vendorName;
        payload.invNo=seleneResultset.invNo;
        payload.invDate=seleneResultset.invDate;
        payload.poNo=seleneResultset.poNo;
        payload.acctNo=seleneResultset.acctNo; 
        payload.projectNo=seleneResultset.projectNo;
        payload.terms=seleneResultset.terms;
        payload.tax=seleneResultset.tax;
        payload.additional=seleneResultset.additional;
        payload.total=seleneResultset.total;
        payload.isInvalidDoc=seleneResultset.isInvalidDoc?seleneResultset.isInvalidDoc:false;
        payload.isOverrideVendorName=seleneResultset.isOverrideVendorName?seleneResultset.isOverrideVendorName:false;
    }

    if (selene.reviewQuestions && selene.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(seleneResultset,selene.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.SELENE_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.SELENE_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.SELENE_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.SELENE_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,workflowType.toLowerCase())
    .then((resp) => resp.json()).then(data =>{
        
        dispatch({type: actionTypes.REFRESH_SELENE_VENDORS_SUCCESS, vendors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_SELENE_VENDORS_ERROR, error: err});
    })
}

export const refreshCacheValue=(key:any, value:any)=>{
    return { type: actionTypes.REFRESH_SELENE_CACHE_VALUE, anyKey: key, anyValue: value }
}


// WEBPACK FOOTER //
// ./src/redux/selene/actions.js